export default __webpack_public_path__ + "static/media/Sage's Vestment of Shimmering Light.3422e6b8.jpg";